<div id="main-cont" class="container-fluid h-100 px-0">
  <!-- Toasts stack in one region; errors interrupt, success and progress are announced politely. -->
  <div class="toast-region">
    <div class="toast-live" role="alert">
      @if (errorMsg) {
        <div class="app-toast app-toast-error">
          <img class="app-toast-icon" alt="" width="20" height="20" src="assets/icons/toast/error.svg" />
          <div class="app-toast-body">
            <p class="app-toast-title">Error</p>
            <p class="app-toast-message">{{ errorMsg }}</p>
          </div>
          <button
            type="button"
            class="app-toast-close"
            aria-label="Dismiss error notification"
            (click)="dismissToast('error')"
          >
            <img alt="" width="16" height="16" src="assets/icons/toast/close.svg" />
          </button>
        </div>
      }
    </div>
    <div class="toast-live" role="status" aria-live="polite">
      @if (successMsg) {
        <div class="app-toast app-toast-success">
          <img class="app-toast-icon" alt="" width="20" height="20" src="assets/icons/toast/success.svg" />
          <div class="app-toast-body">
            <p class="app-toast-title">Success</p>
            <p class="app-toast-message">{{ successMsg }}</p>
          </div>
          <button
            type="button"
            class="app-toast-close"
            aria-label="Dismiss success notification"
            (click)="dismissToast('success')"
          >
            <img alt="" width="16" height="16" src="assets/icons/toast/close.svg" />
          </button>
        </div>
      }
      @if (processMsg) {
        <div class="app-toast app-toast-process">
          <span class="spinner-border spinner-border-sm app-toast-icon app-toast-spinner" aria-hidden="true"></span>
          <div class="app-toast-body">
            <p class="app-toast-title">Processing</p>
            <p class="app-toast-message">{{ processMsg }}</p>
          </div>
          <button
            type="button"
            class="app-toast-close"
            aria-label="Dismiss processing notification"
            (click)="dismissToast('process')"
          >
            <img alt="" width="16" height="16" src="assets/icons/toast/close.svg" />
          </button>
        </div>
      }
    </div>
  </div>
  <app-lister-home></app-lister-home>
</div>
